// extracted by mini-css-extract-plugin
export var root = "ContentWithSidebar-module--root--1CNjM";
export var sidebarOpen = "ContentWithSidebar-module--sidebarOpen--rMTy9";